import { emissionFactorManagementAPI } from "../API/emissionFactorManagementAPI";

const API = emissionFactorManagementAPI;
export const EFManagementService = {
  //////// 取得自定義係數資料表
  fetchCustomEFData(parentCId, cIdArr, catArr, standardId, keyword) {
    const requestBody = {
      parent_company_id: parentCId,
      companyIds: cIdArr,
      category: catArr,
      standardId: standardId,
      keyword: keyword,
      page: 1,
      pageSize: 999999,
    };

    return API.getCustomEFList(requestBody);
  },

  //////// 修改自定義EF
  fetchEditEF(id, data) {
    return API.modifyCustomEF(id, data);
  },

  //////// 取得系統係數資料表
  fetchSystemEFData(requestBody) {
    return API.getSystemEFList(requestBody);
  },
};
